import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getNavigationConfig } from '../config/navigation';
import { CORE_STAFF_ROLES } from '../config/roleConfig';
import { useGuestReviewCounts } from '../hooks/useGuestReviews';
import { useComplaintCounts } from '../hooks/useComplaints';
import { formatCount } from '../utils/numberFormatter';
import '../styles/navBadge.css';

const DesktopNavigation = ({ user, activeNavItem, setActiveNavItem }) => {
  const location = useLocation();
  const navigationItems = getNavigationConfig(user?.role);
  // «التقييمات والشكاوى» — ONE counter for the page's three tabs: reviews waiting (post-checkout review O9)
  // plus complaints needing action (tasks/complaints-to-fixes.md C15, C19). Fetched only for the roles that
  // can open the page.
  const isCoreStaff = CORE_STAFF_ROLES.includes(user?.role);
  const { data: reviewCounts } = useGuestReviewCounts(isCoreStaff);
  const { data: complaintCounts } = useComplaintCounts(isCoreStaff);
  const badges = { guestReviews: (reviewCounts?.badge || 0) + (complaintCounts?.badge || 0) };
  const badgeFor = (item) => badges[item.badge] || 0;

  // Function to determine if a navigation item is active
  const isActiveNavItem = (item) => {
    if (activeNavItem) {
      return activeNavItem === item.id;
    }
    // Fallback to location-based detection
    return location.pathname === item.path || 
           (item.path === '/dashboard' && location.pathname === '/');
  };

  // Handle navigation item click
  const handleNavClick = (item) => {
    if (setActiveNavItem) {
      setActiveNavItem(item.id);
    }
  };

  return (
    <aside className="admin-sidebar">
      <div className="sidebar-header">
        <h3>القائمة</h3>
      </div>
      
      <nav className="admin-nav">
        <ul className="admin-nav-list">
          {navigationItems.map((item) => (
            <li key={item.id} className="admin-nav-item">
              <Link
                to={item.path}
                className={`admin-nav-link ${isActiveNavItem(item) ? 'active' : ''}`}
                onClick={() => handleNavClick(item)}
                title={item.description}
              >
                <i className={`${item.icon} admin-nav-icon`}></i>
                {item.label}
                {badgeFor(item) > 0 && (
                  <span className="nav-count-badge" aria-label={`${badgeFor(item)} بانتظار الإجراء`}>
                    {formatCount(badgeFor(item))}
                  </span>
                )}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

    </aside>
  );
};

export default DesktopNavigation;